import React from 'react'
import PropTypes from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'
import { Link as MuiLink } from '@material-ui/core'

import { styled } from '@material-ui/core/styles'

import getRoute from 'src/util/getRoute'

const MuiLinkNoFormatting = styled(MuiLink)({
  color: 'inherit',
  textDecoration: 'inherit',
})

const StyledMuiLink = styled(MuiLink)({
  cursor: 'pointer',
})

const Link = ({
  to,
  href,
  target,
  toDynamic,
  dynamicFunction,
  dontUseRoutes,
  noFormatting,
  ...props
}) => {
  const LinkComponent = noFormatting ? MuiLinkNoFormatting : StyledMuiLink

  // convert dynamic links
  if (dynamicFunction) {
    to = dynamicFunction(getRoute(to))
  }

  // target _blank links open in a new tab and are therefore the same as
  // external links so if we have a target _blank and a to, convert it
  if (target === '_blank' && to) {
    href = dynamicFunction ? to : getRoute(to)
    to = false
  }

  // check if its an internal link
  if (to) {
    if (dontUseRoutes) {
      return <LinkComponent component={GatsbyLink} to={to} {...props} />
    }

    return <LinkComponent component={GatsbyLink} to={getRoute(to)} {...props} />
  } else {
    if (!href && !props.onClick) {
      throw Error('EMPTY LINK')
    }
    return <LinkComponent target={target} href={href} {...props} />
  }
}

Link.propTypes = {
  to: PropTypes.string,
  dontUseRoutes: PropTypes.bool,
}

export default Link
